/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Breadcrumb from '../../../components/Breadcrumb';
import Sidebar from '../../../components/Sidebar/Products';
import s from '../Products.css';
import reactTabs from '!!isomorphic-style-loader!css-loader!../../../../node_modules/react-tabs/style/react-tabs.css';

class CommonBlocks extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root}>
        <Breadcrumb title={this.props.title} />
        <div className={s.container}>
          <Sidebar title={this.props.title} />
          <div className={s.contents}>
            <h1>
              {this.props.title}
            </h1>
            <div className={s.carousel}>
              <Carousel
                autoplay
                initialSlideHeight={431}
                initialSlideWidth={655}
                wrapAround
              >
                <img
                  alt="Common Clay Block 3 Hole"
                  src="/images/products/MB_3H469.jpg"
                />
                <img
                  alt="Common Clay Block 10 Hole"
                  src="/images/products/MB_10H469.jpg"
                />
              </Carousel>
            </div>
            <hr />
            <h1>Specifications</h1>
            <Tabs className={s.root.reactTabs}>
              <TabList>
                <Tab>Common Clay Block 3 Hole</Tab>
                <Tab>Common Clay Block 10 Hole</Tab>
              </TabList>
              <TabPanel>
                <table>
                  <tbody>
                    <tr className={s.alt}>
                      <th>Product Code</th>
                      <td colSpan="2">MB/3H469</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td colSpan="2">Common Clay Block 3 Hole</td>
                    </tr>
                    <tr className={s.alt}>
                      <th>Manufacturer</th>
                      <td colSpan="2">Maybricks, Malaysia</td>
                    </tr>
                    <tr>
                      <th>Application</th>
                      <td colSpan="2">Building</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="3">
                        Test Method MS 76 : 1972 / SS103 : 1974 / BS 3921 1974
                      </th>
                    </tr>
                    <tr>
                      <th rowSpan="3">Typical Dimension</th>
                      <th className={s.small}>Length</th>
                      <td>215 mm (± 3mm)</td>
                    </tr>
                    <tr className={s.alt}>
                      <th className={s.small}>Width</th>
                      <td>100 mm (± 3mm)</td>
                    </tr>
                    <tr>
                      <th className={s.small}>Height</th>
                      <td>135 mm (± 3mm)</td>
                    </tr>
                    <tr className={s.alt}>
                      <th rowSpan="3">
                        Overall Measurement of 24 pcs of Bricks
                      </th>
                      <th className={s.small}>Length</th>
                      <td>5175 mm</td>
                    </tr>
                    <tr>
                      <th className={s.small}>Width</th>
                      <td>2377 mm</td>
                    </tr>
                    <tr className={s.alt}>
                      <th className={s.small}>Height</th>
                      <td>3264 mm</td>
                    </tr>
                    <tr>
                      <th colSpan="2">Approximate Unit Weight</th>
                      <td>4.3 kg</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="2">Approximate No. Per Square Meter</th>
                      <td>33 pcs</td>
                    </tr>
                    <tr>
                      <th colSpan="2">Pieces Per Pallet</th>
                      <td>400 pcs</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="2">
                        Average Unconfined Compressive Strength
                      </th>
                      <td>25.5 N/mm²</td>
                    </tr>
                    <tr>
                      <th colSpan="2">Average Density</th>
                      <td>1478 kg/m³</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="2">
                        Average 5 Hour Boiling Water Absorption
                      </th>
                      <td>14.50%</td>
                    </tr>
                    <tr>
                      <th colSpan="2">
                        Average Mean Wet Skid Resistance Value
                      </th>
                      <td>N.A.</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="2">Efflorescence</th>
                      <td>Nil</td>
                    </tr>
                    <tr>
                      <th colSpan="2">Average Salt Content</th>
                      <td>&lt; 1%</td>
                    </tr>
                    <tr className={s.alt}>
                      <th>Notes</th>
                      <td colSpan="2">
                        Common Block intended for general building work but
                        having no special claim to give an attractive appearance
                      </td>
                    </tr>
                    <tr>
                      <th>Disclaimer</th>
                      <td colSpan="2">
                        This data represents average results from commercial
                        production lots. If specific test results are required,
                        samples should be taken from current production lots.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </TabPanel>
              <TabPanel>
                <table>
                  <tbody>
                    <tr className={s.alt}>
                      <th>Product Code</th>
                      <td colSpan="2">MB/10H469</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td colSpan="2">Common Clay Block 10 Hole</td>
                    </tr>
                    <tr className={s.alt}>
                      <th>Manufactured</th>
                      <td colSpan="2">Maybricks, Malaysia</td>
                    </tr>
                    <tr>
                      <th>Application</th>
                      <td colSpan="2">Building</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="3">
                        Test Method MS 76 : 1972 / SS103 : 1974 / BS 3921 1974
                      </th>
                    </tr>
                    <tr>
                      <th rowSpan="3">Typical Dimension</th>
                      <th className={s.small}>Length</th>
                      <td>215 mm (± 3mm)</td>
                    </tr>
                    <tr className={s.alt}>
                      <th className={s.small}>Width</th>
                      <td>100 mm (± 3mm)</td>
                    </tr>
                    <tr>
                      <th className={s.small}>Height</th>
                      <td>135 mm (± 3mm)</td>
                    </tr>
                    <tr className={s.alt}>
                      <th rowSpan="3">
                        Overall Measurement of 24 pcs of Bricks
                      </th>
                      <th className={s.small}>Length</th>
                      <td>5175 mm</td>
                    </tr>
                    <tr>
                      <th className={s.small}>Width</th>
                      <td>2378 mm</td>
                    </tr>
                    <tr className={s.alt}>
                      <th className={s.small}>Height</th>
                      <td>3273 mm</td>
                    </tr>
                    <tr>
                      <th colSpan="2">Approximate Unit Weight</th>
                      <td>4.2 kg</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="2">Approximate No. Per Square Meter</th>
                      <td>33 pcs</td>
                    </tr>
                    <tr>
                      <th colSpan="2">Pieces Per Pallet</th>
                      <td>400 pcs</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="2">
                        Average Unconfined Compressive Strength
                      </th>
                      <td>26 N/mm²</td>
                    </tr>
                    <tr>
                      <th colSpan="2">Average Density</th>
                      <td>1470 kg/m³</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="2">
                        Average 5 Hour Boiling Water Absorption
                      </th>
                      <td>14.00%</td>
                    </tr>
                    <tr>
                      <th colSpan="2">
                        Average Mean Wet Skid Resistance Value
                      </th>
                      <td>N.A.</td>
                    </tr>
                    <tr className={s.alt}>
                      <th colSpan="2">Efflorescence</th>
                      <td>Nil</td>
                    </tr>
                    <tr>
                      <th colSpan="2">Average Salt Content</th>
                      <td>&lt; 1%</td>
                    </tr>
                    <tr className={s.alt}>
                      <th>Notes</th>
                      <td colSpan="2">
                        Common Block intended for general building work but
                        having no special claim to give an attractive appearance
                      </td>
                    </tr>
                    <tr>
                      <th>Disclaimer</th>
                      <td colSpan="2">
                        This data represents average results from commercial
                        production lots. If specific test results are required,
                        samples should be taken from current production lots.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s, reactTabs)(CommonBlocks);



// WEBPACK FOOTER //
// ./src/routes/products/common-blocks/CommonBlocks.js